import React, { FC } from 'react'
import styled from '@emotion/styled'
import Section from '../components/Section'
import SEO from '../components/SEO'
import Layout from '../components/Layout'
import Paginator from '../components/Navigation/Navigation.Paginator'
import AuthorHero from '../sections/author/Author.Hero'
import AuthorArticles from '../sections/author/Author.Articles'
import { graphql } from 'gatsby'
import { MarkdownQueryI, AllMarkdownRemarkI, PaginationContextI } from '../types/common'
import { SiteMetadataI, PostI, AuthorsI } from '../types/data-models'

interface AuthorPageI {
  data: {
    site: {
      siteMetadata: SiteMetadataI
    }
    posts: AllMarkdownRemarkI<PostI>
    author: MarkdownQueryI<AuthorsI>
  }
  location: Location
  pageContext: PaginationContextI
}

const ArticlesPage: FC<AuthorPageI> = ({ data, location, pageContext }) => {
  const author = data.author.frontmatter
  const articles = data.posts.nodes
  const filteredArticlesByAuthor = articles.filter((article) => article.frontmatter.author === author.name)

  return (
    <Layout>
      <SEO pathname={location.pathname} title={author.name} description={author.bio} />
      <Section narrow>
        <AuthorHero author={author} />
        <AuthorArticles articles={filteredArticlesByAuthor} />
        <AuthorPaginator>
          <Paginator {...pageContext} />
        </AuthorPaginator>
      </Section>
      <AuthorsGradient />
    </Layout>
  )
}

export default ArticlesPage

const AuthorsGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 590px;
  z-index: 0;
  pointer-events: none;
  background: ${(p) => p.theme.colors.gradient};
  transition: ${(p) => p.theme.colorModeTransition};
`

const AuthorPaginator = styled.div`
  text-align: center;
`

export const query = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    posts: allMdx(filter: { fields: { type: { eq: "POST" } }, frontmatter: { isDraft: { eq: false } } }) {
      nodes {
        excerpt
        timeToRead
        fields {
          slug
          type
        }
        frontmatter {
          title
          subtitle
          author
          coverImage {
            label
            url
          }
        }
      }
    }
    author: mdx(fields: { slug: { eq: $slug } }) {
      fields {
        slug
        type
      }
      frontmatter {
        name
        bio
        avatar
        social {
          url
          name
        }
        isFeatured
      }
    }
  }
`
